export default __webpack_public_path__ + "static/media/LOGOS2.3f15cf2a.jpg";